import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { Header, HeaderLabel, HeaderButton } from '../../styles';

interface SlideSelectorProps {
	label: string;
	children: React.ReactNode;
	onCancel: () => void;
}

const SlideSelector = ({
	label,
	children,
	onCancel,
}: SlideSelectorProps) => (
	<div>
		<Header>
			<HeaderButton onClick={onCancel}>
				<Translate value="messages.cancel" />
			</HeaderButton>
			<HeaderLabel value={label} />
		</Header>
		{children}
	</div>
);

export default SlideSelector;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SliderManager/SlideSelector/index.tsx